import { Button, TextInput } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../api/client";
import { errorMessage } from "../../shared/session/errors";
import { FormError, Notice, Page } from "../../shared/ui/Page";

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { response, error } = await api.POST("/auth/forgot-password", { body: { code } });
    if (response.ok) setSent(true);
    else setError(errorMessage(error, t("error.generic")));
  };
  return (
    <Page title={t("forgot.title")}>
      {sent ? (
        <Notice>{t("forgot.sent")}</Notice>
      ) : (
        <form onSubmit={submit}>
          <TextInput
            label={t("forgot.code")}
            value={code}
            onChange={(e) => setCode(e.currentTarget.value)}
            required
            mb="md"
          />
          <FormError message={error} />
          <Button type="submit" fullWidth mt="sm">
            {t("forgot.submit")}
          </Button>
        </form>
      )}
    </Page>
  );
}
